import { Button, Card, Col, Form, Row, Space, Table, Descriptions, message, Tag, Typography, Alert, Modal, Breadcrumb } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { QuestionCircleOutlined } from '@ant-design/icons';
import AttributeRuleDetailEdit from "./detail/AttributeRuleDetailEdit";
import EUtils, { IButtonConfig } from "../../../utils/EUtils";
import Server from "../../../server/Server";
import URL from "../../../server/URL";

const AttributeRuleView = () => {
    const [attributeRuleID, setAttributeRuleID] = useState<any>(null);
    const [attributeRule, setAttributeRule] = useState<any>(null);
    const [dataSource, setDataSource] = useState<any>([]);
    const [modal, contextHolder] = Modal.useModal();

    const [visible, setVisible] = useState(false);
    const [editRecord, setEditRecord] = useState<any>(null);

    const columns: ColumnsType<any> = [
        { title: '序号', dataIndex: 'seqNO', key: 'seqNO', fixed: 'left', align: 'center', ellipsis: true, width: 80, },
        { title: '显示标签', dataIndex: 'showLabel', key: 'showLabel', fixed: 'left', width: 100, ellipsis: true },
        { title: '原标签', dataIndex: 'orgLabel', key: 'orgLabel', width: 100, ellipsis: true },
        {
            title: '填写控制', dataIndex: 'fillControl', key: 'fillControl', width: 100, ellipsis: true,
            render(value, record, index) {
                return record.fillControlEnum == 0 ? <span style={{ color: 'red' }}>{value}</span> : value;
            },
        },
        { title: '填写格式', dataIndex: 'fillFormat', key: 'fillFormat', width: 100, ellipsis: true },
        { title: '默认值', dataIndex: 'defaultValue', key: 'defaultValue', width: 100, ellipsis: true },
        { title: '显示值', dataIndex: 'showValues', key: 'showValues', width: 80, ellipsis: true },
        {
            title: '产品填写控制', dataIndex: 'partFillControl', key: 'partFillControl', width: 120, ellipsis: true,
            render(value, record, index) {
                return record.partFillControlEnum == 0 ? <span style={{ color: 'red' }}>{value}</span> : value;
            },
        },
        {
            title: '入库计划填写控制', dataIndex: 'inPlanFillControl', key: 'inPlanFillControl', width: 150, ellipsis: true,
            render(value, record, index) {
                return record.inPlanFillControlEnum == 0 ? <span style={{ color: 'red' }}>{value}</span> : value;
            },
        },
        {
            title: '是否联动', dataIndex: 'isLinkage', key: 'isLinkage', width: 80, ellipsis: true,
            render(value, record, index) {
                return value ? '√' : <span style={{ color: 'red' }}>{'×'}</span>;
            },
        },
        {
            title: '唯一值', dataIndex: 'isUnique', key: 'isUnique', width: 80, ellipsis: true,
            render(value, record, index) {
                return value ? '√' : <span style={{ color: 'red' }}>{'×'}</span>;
            },
        },
        {
            title: '允许为0', dataIndex: 'isCanZero', key: 'isCanZero', width: 80, ellipsis: true,
            render(value, record, index) {
                return value ? '√' : <span style={{ color: 'red' }}>{'×'}</span>;
            },
        },
        {
            title: '启用', dataIndex: 'isActive', key: 'isActive', width: 50, ellipsis: true, fixed: 'right',
            render(value, record, index) {
                return <Tag color={value ? 'success' : 'error'}>{value ? '启用' : '禁用'}</Tag>;
            },
        },
        {
            title: '操作', fixed: 'right', width: 120, ellipsis: true,
            render(value, record, index) {
                var configs: IButtonConfig[] = [
                    { name: '查看', onClick: () => { onOpen(2, record); } },
                    { name: '编辑', onClick: () => { onOpen(1, record); } },
                    { name: '启用', onClick: () => { onSetActive(record); }, hidden: record.isActive },
                    { name: '禁用', onClick: () => { onSetActive(record); }, hidden: !record.isActive, danger: true },
                    { name: '上移', onClick: () => { onMoveUp(record); }, hidden: record.seqNO == 1 },
                    { name: '下移', onClick: () => { onMoveDown(record); }, hidden: record.seqNO == dataSource.length },
                ];
                return EUtils.InitButtons(configs);
            },
        },]

    const [scrollY, setScrollY] = useState("")
    const resize = () => setScrollY(EUtils.getTableScroll(0, 'attributeRuleDetail'));
    //页面加载完成后才能获取到对应的元素及其位置
    useEffect(() => {
        resize();
    }, [dataSource])

    useEffect(() => {
        var params = EUtils.getUrlParams();
        if (params.attributeRuleID) {
            setAttributeRuleID(params.attributeRuleID);
        }
    }, [])

    useEffect(() => {
        if (attributeRuleID) {
            loadData();
        }
    }, [attributeRuleID])

    var loadData = () => {
        var request = {
            attributeRuleID: attributeRuleID
        };
        Server.Post(URL.AttributeRule.GetAttributeRule, request).then((response: any) => {
            if (response.isSuccess) {
                setAttributeRule(response);
                loadAttributeRuleDetailData();
            }
        })
    }
    const onOpen = (viewMode: number, record: any) => {
        setEditRecord({
            viewMode: viewMode,
            warehouseID: record?.warehouseID,
            attributeRuleDetailID: record?.attributeRuleDetailID,
            showLabel: record?.showLabel,
            attributeRuleID: record?.attributeRuleID,
            attributeRuleNO: record?.attributeRuleNO,
        });
        setVisible(true);
    }

    const onSetActive = (record: any) => {
        modal.confirm({
            title: (record.isActive ? '禁用' : '启用') + '属性',
            icon: <QuestionCircleOutlined />,
            content: <>
                <p>{'确定' + (record.isActive ? '禁用' : '启用') + '属性[' + record.showLabel + ']？'}</p>
            </>,
            okText: '确定',
            cancelText: '取消',
            onOk() {
                var request = {
                    attributeRuleDetailID: record.attributeRuleDetailID,
                    isActive: !record.isActive,
                };
                Server.Post(URL.AttributeRule.SetActiveAttributeRuleDetail, request).then((response: any) => {
                    if (response.isSuccess) {
                        message.success((record.isActive ? '禁用' : '启用') + '成功');
                        loadAttributeRuleDetailData();
                    } else {
                        message.warning(response.returnMsg);
                    }
                })

            },
            onCancel() { },
        });
    }

    const onMoveUp = (record: any) => {
        modal.confirm({
            title: '上移属性',
            icon: <QuestionCircleOutlined />,
            content: <>
                <p>{'确定上移属性[' + record.showLabel + ']？'}</p>
            </>,
            okText: '确定',
            cancelText: '取消',
            onOk() {
                var request = {
                    attributeRuleDetailID: record.attributeRuleDetailID
                };
                Server.Post(URL.AttributeRule.MoveUpAttributeRuleDetail, request).then((response: any) => {
                    if (response.isSuccess) {
                        message.success('上移成功');
                        loadAttributeRuleDetailData();
                    } else {
                        message.warning(response.returnMsg);
                    }
                })

            },
            onCancel() { },
        });
    }

    const onMoveDown = (record: any) => {
        modal.confirm({
            title: '下移属性',
            icon: <QuestionCircleOutlined />,
            content: <>
                <p>{'确定下移属性[' + record.showLabel + ']？'}</p>
            </>,
            okText: '确定',
            cancelText: '取消',
            onOk() {
                var request = {
                    attributeRuleDetailID: record.attributeRuleDetailID
                };
                Server.Post(URL.AttributeRule.MoveDownAttributeRuleDetail, request).then((response: any) => {
                    if (response.isSuccess) {
                        message.success('下移成功');
                        loadAttributeRuleDetailData();
                    } else {
                        message.warning(response.returnMsg);
                    }
                })

            },
            onCancel() { },
        });
    }

    var loadAttributeRuleDetailData = () => {
        var request = {
            attributeRuleID: attributeRuleID
        };
        Server.Post(URL.AttributeRule.GetAttributeRuleDetailList, request).then((response: any) => {
            if (response.isSuccess) {
                setDataSource(response.data);
            }
        })
    }

    return <>
        <div style={{ borderBottom: '1px solid #d9d9d9', height: '38px', verticalAlign: 'middle' }}>
            {/* <Breadcrumb style={{ float: 'left', margin: '5px' }}
                items={[
                    {
                        title: '属性规则信息',
                    },
                ]}
            /> */}
            <Space style={{ float: 'right', margin: '2px' }}>
                <Button onClick={() => { window.history.back() }}>返回</Button>
            </Space>
        </div>
        <div style={{ marginTop: '5px' }}>
            <Descriptions size="small" column={2}>
                <Descriptions.Item label={'规则名称'}>{attributeRule?.attributeRuleName}</Descriptions.Item>
                <Descriptions.Item label={'规则类型'}>{attributeRule?.type}</Descriptions.Item>
                <Descriptions.Item label={'规则描述'} span={2}>{attributeRule?.remark}</Descriptions.Item>
            </Descriptions>
        </div>
        <div style={{ paddingTop: '2px' }}>
            <div style={{ backgroundColor: '#fafafa', border: '1px solid #e7e7eb', padding: '5px' }}>
                <span style={{ lineHeight: '32px', margin: '5px', fontWeight: 'bold' }}>{'属性列表'}</span>
                <Space style={{ float: 'right' }}>
                    <Alert style={{ padding: '5px' }} message={'提醒：自定义属性慎重修改，一旦修改可能影响到业务，修改前请联系系统管理员'}
                        type="warning" banner />
                </Space>
            </div>
            <Table size="small" bordered
                id={'attributeRuleDetail'}
                scroll={{ x: 'max-content', y: scrollY }}
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                summary={(pageData) => {
                    return (
                        <Table.Summary fixed>
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0} >
                                    <Typography>{'合计：' + pageData.length}</Typography>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1}></Table.Summary.Cell>
                                <Table.Summary.Cell index={2} colSpan={10}></Table.Summary.Cell>
                                <Table.Summary.Cell index={3} colSpan={1}></Table.Summary.Cell>
                                <Table.Summary.Cell index={4} colSpan={1}></Table.Summary.Cell>
                            </Table.Summary.Row>
                        </Table.Summary>
                    );
                }} />
        </div>
        <AttributeRuleDetailEdit visible={visible} {...editRecord} setVisibel={setVisible} reLoad={loadData} />
        {contextHolder}
    </>
}
export default AttributeRuleView;